<template>
  <div class="login-wrap">
    <h1 class="login-title">战略情报系统</h1>

    <div class="login-box">
      <div style="margin-bottom: 10px">
        <i class="el-icon-user"></i>
        <el-input
          type="text"
          placeholder="请输入用户名"
          v-model="userIput"
          style="width: 200px"
          size="small"
        >
        </el-input>
      </div>
      <div style="margin-bottom: 20px">
        <i class="el-icon-lock"></i>
        <el-input
          placeholder="请输入密码"
          v-model="passwordInput"
          show-password
          style="width: 200px"
          size="small"
        ></el-input>
      </div>
      <div style="margin-bottom: 20px" v-if="isRegisterMode">
        <i class="el-icon-lock"></i>
        <el-input
          placeholder="请确认密码"
          v-model="passwordReInput"
          show-password
          style="width: 200px"
          size="small"
        ></el-input>
      </div>
      <div v-if="!isRegisterMode">
        <el-button
          type="primary"
          size="small"
          @click="login"
          style="width: 80px; margin-right: 15px"
          >登录</el-button
        >
        <!-- <el-button type="primary" size="small" @click="register" style="width: 80px">注册</el-button> -->
        <a @click="register" style="color: #ba0d0d">注册</a>
      </div>

      <div v-if="isRegisterMode">
        <el-button
          type="primary"
          size="small"
          @click="SuccessRegister"
          style="width: 80px; margin-right: 15px"
          >注册</el-button
        >
      </div>
    </div>
    <div style="margin-top:20px">版本号:{{this.verson}}</div>
  </div>
</template>

<script>
import config from "../../../package.json"
import { initData } from "@/views/News/index";
import api from "@/services/python";
export default {
  components: {},
  data() {
    return {
      userIput: "admin",
      passwordInput: "123456",
      passwordReInput: "",
      isRegisterMode: false,
      verson:config.version
    };
  },
  methods: {
    /**
     * 登录点击事件
     */
    // login() {
    //   if (this.validate()) {
    //     // 登录检验
    //     //先更新状态
    //     this.$store.commit("setIsLogin", true)

    //     //跳转到搜索引擎页面
    //     this.$router.push("/SearchEngine")
    //     // this.$router.push("/Newpage")
    //     this.$message.success("登录成功")

    //     // //初始化中国数据
    //     // this.init()
    //   } else {
    //     this.$message.warning("密码错误")
    //   }
    // },
    async login() {
      if (this.validate()) {
        const params = {
          username: this.userIput,
          password: this.passwordInput,
        };
        const res = await api.user.auth(params).response.then((res) => res.data);
        if (res.code === 200) {
           //跳转到搜索引擎页面
           this.$store.commit("setIsLogin", true);
               this.$router.push("/SearchEngine")
          // this.$router.push("/IntelligenceField");
          this.$message.success("登录成功");
          //存入sessionStorage
          sessionStorage.setItem("admin",JSON.stringify(res.data));
        } else {
          this.$message.error(res.msg);
        }
      }
    },
    /**
     * 登录校验
     */
    validate() {
      return true;
    },

    /**
     * 注册点击事件
     */
    register() {
      this.isRegisterMode = true;
      this.userIput = "";
      this.passwordInput = "";
    },

    /**
     * 注册成功跳转登录页
     */
    async SuccessRegister() {
      const params = {
        username: this.userIput,
        password: this.passwordReInput,
      };
      const res = await api.user
        .create(params)
        .response.then((res) => res.data);
      if (res.code === 200) {
        if (!this.userIput) {
          this.$message.warning("用户名不能为空");
          return;
        } else if (!this.passwordInput) {
          this.$message.warning("密码不能为空");
          return;
        } else if (!this.passwordReInput) {
          this.$message.warning("请再次输入密码");
          return;
        } else if (this.passwordReInput !== this.passwordInput) {
          this.$message.warning("两次输入密码不相同，请重新输入");
          return;
        }
        this.$message({
          message: "注册成功，请重新登录",
          type: "success",
        });
        this.isRegisterMode = false;
      } else {
        this.$message.error(res.msg);
      }
    },

    async init() {
      // console.log(await initData(this, "中国", false))
      this.$store.commit("setChinaValue", await initData(this, "中国"));
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.login-wrap {
  display: flex;
  /* height: calc(100vh - 55px); */
  flex-direction: column;
  position: relative;
  top: 18vh;
  align-items: center;
  .login-title {
    font-size: 40px;
    box-shadow: 5px 5px 20px #888888;
    letter-spacing: 5px;
  }
  .login-box {
    -moz-box-shadow: inset 0 0 10px #ccc;
    -webkit-box-shadow: inset 0 0 10px #ccc;
    box-shadow: inset 0 0 10px #ccc;
    border-radius: 5%;
    width: 500px;
    height: 250px;
    margin-top: 80px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    i {
      font-size: large;
    }
    .el-input {
      margin-left: 5px;
    }
    // input {
    //   background-color: #00031455;
    //   border-radius: 10%;
    // }
  }
}
</style>
